import { useState } from 'react';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppText } from 'shared/UI/UIKit/Text';
import { useDeleteTeacherWorkloadMutation } from 'shared/api';
import { TeacherWorkloadModalFooter } from 'entities/teacher-workload/modal-footer';
import type { TeacherWorkload } from 'shared/api';

type RemoveTeacherWorkloadModalProps = {
  visible: boolean;
  hide: () => void;
  onSuccess: () => void;
  workload: TeacherWorkload | null;
};

export const RemoveTeacherWorkloadModal = ({
  visible,
  hide,
  onSuccess,
  workload,
}: RemoveTeacherWorkloadModalProps) => {
  const [loading, setLoading] = useState(false);
  const [deleteTeacherWorkload] = useDeleteTeacherWorkloadMutation();

  const onRemove = () => {
    if (!workload) return;

    setLoading(true);
    deleteTeacherWorkload(workload.id)
      .unwrap()
      .then(() => {
        hide();
        onSuccess();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const footer = (
    <TeacherWorkloadModalFooter onSubmit={onRemove} hideModal={hide} title="Удалить" />
  );

  const content = (
    <AppFlex unit="8">
      <AppText size={16} type="secondary">
        Подтвердите удаление нагрузки учителя
      </AppText>
      <AppText size={18}>{workload?.code}</AppText>
    </AppFlex>
  );

  return (
    <AppModal
      visible={visible}
      onCancel={hide}
      size="auto"
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title={`Удалить нагрузку учителя ${workload?.code || ''}`}
      maskClosable={false}
    />
  );
};
